import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import {
  SPECIAL_FIELDS,
  SPECIAL_FIELDS_DATA
} from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";

export class ServicesPropertiesValues extends ListOfPropertiesValues {
  cups = this.findCups;
  serviceTemplate = this.getServiceTemplates;
  sectionKey = this.getSections;
  groupKey = this.getGroups;
  firstAndLastService = () =>
    this.getServiceSpecialFieldData(SPECIAL_FIELDS[8]);
  twoLastServices = () => this.getServiceSpecialFieldData(SPECIAL_FIELDS[9]);
  secondToLastService = () =>
    this.getServiceSpecialFieldData(SPECIAL_FIELDS[7]);
  lastService = () => this.getServiceSpecialFieldData(SPECIAL_FIELDS[6]);
  firstService = () => this.getServiceSpecialFieldData(SPECIAL_FIELDS[5]);
  user = this.getDocument;
  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof ServicesPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof ServicesPropertiesValues]();
  }

  findCups() {
    return this.getCups();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getServiceTemplates() {
    return await this.getServiceTemplatesCommonFunction();
  }

  async addSectionsOrGroups(valueOfField: { id: string; name: string }[]) {
    return await this.addSectionsOrGroupsCommonFunction(
      valueOfField,
      this.indexSectionOfDashboard
    );
  }

  getSections() {
    return this.getSectionsCommonFunctions(this.indexSectionOfDashboard);
  }
  getGroups() {
    return this.getGroupsCommonFunctions(this.indexSectionOfDashboard);
  }

  getServiceSpecialFieldData(fieldKey: string) {
    return SPECIAL_FIELDS_DATA[fieldKey] ?? { data: [] };
  }
}
